
/**
 *
 * @class UserLogEntryHelper
 *
 * @brief common methods used by the builders
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2021
 *
 */
export class UserLogEntryHelper {

  public static trackString(data: any) {

    let label: string = '';

    if (data.b != null) {

      label += data.b.d;
    }

    if (data.a != null) {

      if (label != '') {

        label += ' / ';
      }

      label += `${data.a.d}`;
    }

    label += `${data.t} ${data.m} mi`;

    return label;
  }

  /** helper for format decision point pair naming */
  public static afterLabel(before: any, after: any) {

    let label = '';

    if (before) {

      before.name = before.name.trim();

      if (before.name != '') {

        label += before.name;
      }

    }

    if (after) {

      after.name = after.name.trim();

      if (after.name != '') {

        label += ` / ${after.name}`;
      }

    }

    return label;
  }

  /** helper to parse raw authority data items */
  public static parseAuthority(data: any) {

    let authorities: any[]            = [];
    let opposingTrains: any[]         = [];

    let follower: any                 = null;

    let train: any                    = {
      direction:        data.t.d,
      name:             data.t.n,
      parentTemplateId: data.t.p,
      kind:             data.t.t,
      id:               data.t.u
    }

    const reason: string              = data.r;
    const proposedMoveExited: boolean = data.pme;
    const authByFWD: boolean          = data.abf;

    if (data.f != null) {

      follower = {
        direction:        data.f.d,
        name:             data.f.n,
        parentTemplateId: data.f.p,
        kind:             data.f.t,
        id:               data.f.u
      }
    }

    /* opposing trains... */

    data.o.forEach((opTrain)         => {

      opposingTrains.push({
        id:               opTrain.u,
        parentTemplateId: opTrain.p,
        kind:             opTrain.t,
        name:             opTrain.name,
        direction:        opTrain.d
      });

    });

    /* authorities... */

    data.a.forEach((authItem)         => {

      /* target track for this authority */

      let before = null;
      let after  = null;

      if ((authItem.t.b != null) && (typeof authItem.t.b.d != 'undefined')) {

        before = {
          name:    authItem.t.b.d,
          mileage: authItem.t.b.m
        }
      }

      if ((authItem.t.a != null) && (typeof authItem.t.a.d != 'undefined')) {

        after = {
          name:    authItem.t.a.d,
          mileage: authItem.t.a.m
        }
      }

      const track: any     = {
        desc:    authItem.t.t,
        id:      authItem.t.i,
        mileage: authItem.t.m,
        before,
        after
      };

      let  route: any      = null;

      if (authItem.r != null) {

        route = {
          id:              authItem.r.i,
          status:          authItem.r.f,
          statusOtherWay:  authItem.r.b,
          mask:            authItem.r.m
        };
      }

      authorities.push({
        track,
        route
      });

    });

    /* build the node! */

    return {
      train,
      follower,
      reason,
      proposedMoveExited,
      authByFWD,
      authorities,
      opposingTrains
    };
  }
}
